import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import LockingRewardsPage from "../pages/locking-rewards/page";
import LockingPage from "../pages/locking/page";
import NewsPage from "../pages/news/page";
import TokenomicsPage from "../pages/tokenomics/page";
import SecurityPage from "../pages/security/page";
import BeginnerPage from "../pages/beginner/page";
import CommunityPage from "../pages/community/page";
import RewardClaimManualPage from "../pages/reward-claim-manual/page";
import ContactPage from "../pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/locking",
    element: <LockingPage />,
  },
  {
    path: "/reward-claim-manual",
    element: <RewardClaimManualPage />,
  },
  {
    path: "/security",
    element: <SecurityPage />,
  },
  {
    path: "/beginner",
    element: <BeginnerPage />,
  },
  {
    path: "/news",
    element: <NewsPage />,
  },
  {
    path: "/community",
    element: <CommunityPage />,
  },
  {
    path: "/tokenomics",
    element: <TokenomicsPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "/locking-rewards",
    element: <LockingRewardsPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;